import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTinPlatingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Tin plating" }),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round",
			strokeLinecap: "round",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m9 64 41-24 41 24v5L50 93 9 69Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m9 64 41 24 41-24M50 88v5",
					fill: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m32 22 25-14 19 11-4 11-25 14-19-11Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m32 22 19 11 25-14M51 33l-4 11",
					fill: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m37 22 20-11m-20 17 9 5",
					fill: "none"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M49 45c-2 4-7 8-7 12a7 7 0 0 0 14 0c0-4-5-8-7-12Z"
			}), /* @__PURE__ */ _jsx("path", { d: "m28 64 22 13 22-13M28 70l22 13 22-13M46 57c0 2 1 3 3 3" })]
		})
	]
});
export default SvgTinPlatingSm;
